module.exports = __webpack_public_path__ + "static/media/اكواخ ريفيه في انترلاكن.fe648c49.jpg";